import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import Unauthorized from '@/components/Unauthorized';
import { authSelector } from '@/store';
import { canAccessLotteryFeature } from '@/utils/lotteryAccess';

export function LotteryAccessGuard({ children }: { children: ReactNode }) {
  const { data } = useSelector(authSelector);

  if (!canAccessLotteryFeature(data.roleValue, data.privileges)) {
    return <Unauthorized />;
  }

  return <>{children}</>;
}
